import { render } from "./ToButton.vue?vue&type=template&id=10ee53ad&ts=true"
import script from "./ToButton.vue?vue&type=script&lang=ts"
export * from "./ToButton.vue?vue&type=script&lang=ts"

import "./ToButton.vue?vue&type=style&index=0&id=10ee53ad&lang=css"

import exportComponent from "C:\\vue项目\\fushuliang2024\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__